// extracted by mini-css-extract-plugin
export default {"newItem":"_1ry2g","alwaysShow":"_24dQR"};